export let config = {
  baseUrl: "https://blog.minikubes.com/api/",
  imgBaseUrl: "https://blog.minikubes.com",
  customerBaseUrl:'https://customer-api.ibanera.com/api/v1/',
  customerBaseUrlV2:'https://customer-api.ibanera.com/api/v2/',
  redirectUrl:'https://customer.ibanera.com/',
  DisplayPORTL: false
};
